import { Module } from 'vuex';
import { RootState } from '../rootState';
import { getDefaultState } from './initialState';
import { IAchievementMisc } from './types';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

const state: IAchievementMisc = getDefaultState();
export const achievementMisc: Module<IAchievementMisc, RootState> = {
    state,
    actions,
    getters,
    mutations,
    namespaced: true
};
